export type SectionId =
  | "news"
  | "residential"
  | "commercial"
  | "policy"
  | "infrastructure"
  | "luxury"
  | "finance"
  | "cities"
  | "opinion";

export interface Section {
  id: SectionId;
  label: string;
  blurb: string;
}

export const SECTIONS: Section[] = [
  { id: "news", label: "News", blurb: "The biggest property stories in India, as they break." },
  { id: "residential", label: "Residential", blurb: "Apartments, plots, villas, launches and what buyers are paying." },
  { id: "commercial", label: "Commercial", blurb: "Offices, retail, warehousing, data centres and the deals behind them." },
  { id: "policy", label: "RERA & Policy", blurb: "Regulation, courts, stamp duty, taxes and the rules that move markets." },
  { id: "infrastructure", label: "Infrastructure", blurb: "Metros, expressways, airports and the corridors reshaping land prices." },
  { id: "luxury", label: "Luxury", blurb: "Penthouses, sea-facing towers, farmhouses and trophy homes." },
  { id: "finance", label: "Home Loans", blurb: "Rates, EMIs, eligibility and how to pay for your home." },
  { id: "cities", label: "Cities", blurb: "Mumbai, Delhi NCR, Bengaluru, Hyderabad, Pune, Chennai and beyond." },
  { id: "opinion", label: "Opinion", blurb: "Columnists and experts on where Indian real estate is headed." },
];

export const sectionById = (id: string) => SECTIONS.find(s => s.id === id);

export const CITIES = ["Mumbai", "Delhi NCR", "Bengaluru", "Hyderabad", "Pune", "Chennai", "Kolkata", "Ahmedabad"] as const;
